export default __webpack_public_path__ + "static/media/home_ilm_icon.0420d71a.svg";